import { createSlice } from '@reduxjs/toolkit';

const projectAssignCancelStateSlice = createSlice({
  name: 'projectAssignCancelState',
  initialState: {
    employeesCancelAssignedRefresh: false,
  },
  reducers: {
    triggerEmployeesCancelAssignedRefresh: (state) => {
      state.employeesCancelAssignedRefresh = !state.employeesCancelAssignedRefresh;
    },
  },
});

export const {  
  triggerEmployeesCancelAssignedRefresh
} = projectAssignCancelStateSlice.actions;
export default projectAssignCancelStateSlice.reducer;
